
import { IFilter } from "../interfaces/ifilter";
import { IFilterModel } from "../interfaces/ifilter-event";

export class Filter {

    public filters: IFilter[] = [];

    public filterModel: IFilterModel[] = [];

    page(number: number) {
        let indexFilter = this.getFilterByKey("page");

        let filter: IFilter = {
            id: this.filters.length + 1,
            key: "page",
            property: 'page',
            value: number
        }

        if(indexFilter != -1) {
            this.filters[indexFilter] = filter;
        } else {
            this.filters.push(filter);
        }
        return this;
    }


     size(number: number) {
        let indexFilter = this.getFilterByKey("itemsPerPage");
        let filter: IFilter = {
            id: this.filters.length + 1,
            key: "itemsPerPage",
            property: 'itemsPerPage',
            value: number
        }
        if(indexFilter != -1) {
            this.filters[indexFilter] = filter;
        } else {
            this.filters.push(filter);
        }
        return this;
    }

    order(field: string, order: 'ASC' | 'DESC') {
        let indexFilter = this.getFilterByKey("order");
        let filter: IFilter = {
            id: this.filters.length + 1,
            key: "order",
            property: 'order',
            fields: [field],
            value: order
        }
        if(indexFilter != -1) {
            this.filters[indexFilter] = filter;
        } else {
            this.filters.push(filter);
        }
        return this;
    }

    exist(field: string) {
        let indexFilter = this.getFilterByKey("exists");
        let filter: IFilter = {
            id: this.filters.length + 1,
            key: "exists",
            property: 'exists',
            fields: [field],
            value: true
        }
        if(indexFilter != -1) {
            this.filters[indexFilter] = filter;
        } else {
            this.filters.push(filter);
        }
        return this;
    }

    date(field: string, date: string, operator: "before" | "after") {
        let indexFilter = this.getFilterByKey("date["+operator+"]");
        let filter: IFilter = {
            id: this.filters.length + 1,
            indetifier: "date",
            key: "date["+operator+"]",
            property: field,
            fields: [operator],
            value: date
        }
        if(indexFilter != -1) {
            this.filters[indexFilter] = filter;
        } else {
            this.filters.push(filter);
        }
        return this;
    }

    clearDate(key: string) {
        this.filters = this.filters.filter((f: IFilter) => f.indetifier != key);
        return this;
    }

     search(fields: string[], text: string) {
        let indexFilter = this.getFilterByKey("search");
        if(text.length > 0) {
            let filter: IFilter = {
                id: this.filters.length + 1,
                key: "search",
                property: 'search',
                fields: fields,
                value: text
            }
            if(indexFilter != -1) {
                this.filters[indexFilter] = filter;
            } else {
                this.filters.push(filter);
            }
        } else {
            this.filters.splice(indexFilter, 1);
        }
        return this;
    }

    clearSearch() { 
        this.filters = this.filters.filter((f: IFilter) => f.key != "search");
        return this;
    }

    setSearch(fields: string[], text: string) {
        if(text.length > 0) {
            let filter: IFilter = {
                id: this.filters.length + 1,
                key: "search",
                property: 'search',
                fields: fields,
                value: text
            }
        
            this.filters.push(filter);
        }
            
        return this;
    }

    or(fields: string[], text: string) {
        let indexFilter = this.getFilterByKey("or");
        if(text.length > 0) {
            let filter: IFilter = {
                id: this.filters.length + 1,
                key: "or",
                property: 'or',
                fields: fields,
                value: text
            }
            if(indexFilter != -1) {
                this.filters[indexFilter] = filter;
            } else {
                this.filters.push(filter);
            }
        } else {
            this.filters.splice(indexFilter, 1);
        }
        return this;
    }

     filter(field: string, value: string | number | boolean, operator: "AND" | "IN" = "AND") {
        let indexFilter = this.getFilterByKey(field);
        let valueFilter = this.getFilterByValueIsKey(value, field);
        let operatorMap = operator == "IN" ? "[]" : "";
        let property = field + operatorMap;
        let filter: IFilter = {
            key: field,
            id: this.filters.length + 1,
            property: property,
            value: value
        }

        if(indexFilter != -1 && operator == "AND") {
            this.filters[indexFilter] = filter;
        } else {
            if(valueFilter == -1) {
                this.filters.push(filter);
            }
        }
        return this;
    }


    clearFilter(field: string) {
        this.filters = this.filters.filter((f: IFilter) => !f.key?.includes(field));
        return this;
    }

    clearAllFilter() {
        this.filters =  this.filters.filter((f: IFilter) => !f.key?.includes("search"));
        return this;
    }

    clear() {
        this.filters = [];
        return this;    
    }

    getFilterValue(key: string) {
        let indexFilter = this.getFilterByKey(key);
        if(indexFilter != -1) {
            return this.filters[indexFilter].value;
        }
        return null;
    }


    
    setFilter(key: string, filter: IFilter[]) {
        this.filters = this.filters.filter((f: IFilter) => f.key != key);
        this.filters.push(...filter);
    }

    removeFilter(key: string) {
        this.filters = this.filters.filter((f: IFilter) => f.key != key);
    }

    removeByFilter(filterModel: IFilterModel, position: number) {
        let findFilter = this.filterModel.find((f: IFilterModel) => f.key == filterModel.key);
        console.log(findFilter);
        if(findFilter) {
            console.log(position);
            findFilter.filter.splice(position, 1);
            //this.setfilter(findFilter.key, findFilter.filter);
        }
    }

    setFilterModel(filterModel: IFilterModel) {
        this.filterModel = this.filterModel.filter((f: IFilterModel) => f.key != filterModel.key);
        this.filterModel.push(filterModel);

        //this.setfilter(filterModel.key, filterModel.filter);
    }

    removeFilterModel(filterModel: IFilterModel) {
        this.filterModel = this.filterModel.filter((f: IFilterModel) => f.key != filterModel.key);
        this.removeFilter(filterModel.key);
    }

     convertFilterInQuery() {
        let queryParams = '';
        let filters = this.filters;
        if(filters.length > 0) {
          queryParams = filters.map((filter: IFilter) => {
              let param = `${filter.property}`;
              if(filter.fields) {
                if(filter.fields?.length > 0) {
                    param += `[${filter.fields?.join(',')}]`;
                } else {
                    param += `[]`;
                }
              }
    
              param += `=${filter.value}`;
              return param;
          }).join('&');
          queryParams = `?${queryParams}`;
        }
        return queryParams;
    }

    parseQueryParams(query: string): this {
        if (!query.startsWith('?')) return this;

        // Remove o "?" do início
        const queryString = query.substring(1);

        const params = new URLSearchParams(queryString);
        console.log(params);

        params.forEach((value, fullKey) => {
            console.log(value, fullKey);
            let key = fullKey;
            let fields: string[] = [];

            // Verifica se há campos em colchetes, ex: search[nome,email]
            const match = fullKey.match(/^([^\[]+)\[([^\]]*)\]$/);
            if (match) {
                key = match[1];
                const fieldString = match[2];
                fields = fieldString.length > 0 ? fieldString.split(',') : [];
            }

            let values = value.split(',');
            let filters = values.map((v: string) => {
                return {
                    id: this.filters.length + 1,
                    key: key,
                    property: fullKey,
                    value: v,
                    ...(fields.length > 0 ? { fields } : {})
                }
            })
        
            this.filters.push(...filters);
        });

        return this;
    }

    public getFilter(key: string) {
        return this.filters.filter((filter: IFilter) => filter.key == key);
    }

    public getFilterByKey(key: string) {
        return this.filters.findIndex((filter: IFilter) => filter.key == key);
    }

    private getFilterByValue(value: string | number) {
        return this.filters.findIndex((filter: IFilter) => filter.value == value);
    }

    private getFilterByValueIsKey(value: string | number | boolean, key: string) {
        return this.filters.findIndex((filter: IFilter) => filter.value == value && filter.key == key);
    }
}
